


























































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import productReviewApi from '@/api/goods/productReview/index'
@Component({
  components: {}
})
export default class EvaluateDetail extends AbpBase {
  productreviewInfo: any = {}
  formCustom = { content: null }
  ruleCustom = {
    content: [{ required: true, message: '请输入回复内容', trigger: 'blur' }]
  }

  created() {
    this.getProductreviewInfo()
  }

  /**
   * 获取商品评论详情
   */
  getProductreviewInfo() {
    let id = this.$route.query['id']
    if (id) {
      productReviewApi.getProductreviewInfo(id.toString()).then(res => {
        if (res.data) {
          this.productreviewInfo = res.data
        }
      })
    }
  }

  goFn() {
    if (this.productreviewInfo.orderId) {
      this.$router.push({
        name: 'orderDetail',
        query: {
          id: this.productreviewInfo.orderId
        }
      })
    }
  }

  /**
   * 回复评论
   */
  replyFn() {
    let vm = this
    let formCustom: any = vm.$refs.formCustom
    let id = this.$route.query['id']
    formCustom.validate(valid => {
      if (valid && id) {
        productReviewApi.replyFn(id.toString(), vm.formCustom.content).then(res => {
          this.$Notice.success({
            desc: '回复成功'
          })
          this.formCustom.content = null
          this.getProductreviewInfo()
        })
      }
    }) 
  }
}
